export enum INTEGRATION_TYPE {
  VOIP_CALL = 'voipCall',
  VOIP_SMS = 'voipSms',
  SUMMARY = 'summary',
  EMAIL = 'email',
  SYNC = 'sync',
  MAIL = 'mail',

  RINGLESS_VM = 'ringlessVm',
}

export const VOIP_CALL = [
  'phonecom',
  'ringcentral',
  'currentClient',
  'openphone',
  'dialpad',
  'goto',
  'simplii',
  'intulse',
  'talkdesk',
  'zoom',
] as const;

export const VOIP_SMS = [
  'phonecom',
  'dialpad',
  'ringcentral',
  'currentClient',
  'intulse_external',
  'openphone',
  'simpletexting',
  'simplii',
  'textrequest',
] as const;

export const SYNC = [
  'mailboxpower',
  'directmailmanager',
  'phonecom',
  'dialpad',
  'aweber',
  'thanksio',
  'mailchimp',
  'constantcontact',
] as const;

export const MAIL = ['thanksio', 'directmailmanager'] as const;
export const EMAIL = ['gmail', 'microsoft'] as const;
export const RINGLESS_VM = ['slybroadcast'] as const;
export const SUMMARY = ['openphone'] as const;

export const INTEGRATION_OPTIONS: Record<INTEGRATION_TYPE, readonly string[]> = {
  [INTEGRATION_TYPE.VOIP_CALL]: VOIP_CALL,
  [INTEGRATION_TYPE.VOIP_SMS]: VOIP_SMS,
  [INTEGRATION_TYPE.EMAIL]: EMAIL,
  [INTEGRATION_TYPE.MAIL]: MAIL,
  [INTEGRATION_TYPE.SYNC]: SYNC,
  [INTEGRATION_TYPE.RINGLESS_VM]: RINGLESS_VM,
  [INTEGRATION_TYPE.SUMMARY]: SUMMARY,
};

const _check: Record<INTEGRATION_TYPE, readonly string[]> = INTEGRATION_OPTIONS;
void _check;
